export const stkRtPrecision = 2;
export const taxRelations = ['상증세법상 비특수관계', '소득세법/상증세법 특수관계', '소득세법 비특수관계/상증세법 특수관계'];